module.exports = __webpack_public_path__ + "static/why-jenga-two-15bb506e681450eabc39491d15dacfd3.svg";